<form [formGroup]="stepForm" *ngIf="stepForm">
  <div class="col-12">
    <h5 class="nmbcol">{{ 'Sellers.Products.ExtraInfo' | translate }} </h5>
    <div class="cardbg-white">
      <div class="row">
        <div class="col-6 mb-3">
          <app-image [fieldObject]="controllers['image']" [fieldErrors]="formValidator.formErrors"
            [formControlRef]="convertControls(controllers['image'].fieldName)" [productType]="productTypeId"
            [isUpdate]="isUpdate"></app-image>
        </div>
      </div>
    </div>
  </div>
  <div class="cardbg-white my-3">
    <div class="row justify-content-center mx-0 mb-4">
      <div class="col-md-6 mb-3">
        <app-number [fieldObject]="controllers['price']" [fieldErrors]="formValidator.formErrors"
          [formControlRef]="convertControls(controllers['price'].fieldName)" [productType]="productTypeId"
          [isUpdate]="isUpdate"></app-number>
      </div>
      <div class="col-md-6 mb-3">
        <app-number [fieldObject]="controllers['maxAttendees']" [fieldErrors]="formValidator.formErrors"
          [formControlRef]="convertControls(controllers['maxAttendees'].fieldName)" [productType]="productTypeId"
          [isUpdate]="isUpdate"></app-number>
      </div>
      <div class="col-md-6 mb-3">
        <mat-calendar [minDate]="minDate" [dateClass]="dateClass.bind(this)" #calendar [maxDate]="maxDate"
          class="border rounded" (selectedChange)="handleDateChange($event, calendar)">
        </mat-calendar>
      </div>
    </div>
  </div>
  <div class="col-md-12">
    <h6 class="nmbcol">{{ 'Sellers.Products.AddSlot' | translate }} </h6>
    <div class="cardbg-white my-3">
      <app-calendar-slot (hasNoSlot)="updateValue($event)" [fieldObject]="controllers['Slots']"
        [fieldErrors]="formValidator.formErrors" [formControlRef]="convertControls(controllers['Slots'].fieldName)"
        [productType]="productTypeId" [isUpdate]="isUpdate"
        (reflectScheduleValuesToCalender)="onReflectScheduleDatesToCalender($event)"></app-calendar-slot>
    </div>
    <mat-error class="text-danger"
      *ngIf="noSlot">
      {{ 'Sellers.Products.AddSlotWarning' | translate }}
    </mat-error>
  </div>
  <div class="cardbg-white my-3">
    <app-toggle [fieldObject]="controllers['is_buyer_info']" [fieldErrors]="formValidator.formErrors"
      [formControlRef]="convertControls(controllers['is_buyer_info'].fieldName)" [productType]="productTypeId"
      [isUpdate]="isUpdate"></app-toggle>
  </div>
</form>
